import { UserProfileService } from '@/app/services/user-profile'
import { ErrorResponse, PaginatedQueryResponse } from '@/types/api'
import { IWorkAreaTaskSuggestion } from '@/types/work-area-task-suggestion'
import { useQuery, UseQueryOptions } from 'react-query'

export function useWorkAreaTaskSuggestions(
  profileId: string | undefined,
  options?: Omit<
    UseQueryOptions<
      PaginatedQueryResponse<IWorkAreaTaskSuggestion>,
      ErrorResponse
    >,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<PaginatedQueryResponse<IWorkAreaTaskSuggestion>, ErrorResponse>(
    [UserProfileService.GET_PATH, profileId, 'work-area-task-suggestions'],
    () => UserProfileService.postWorkAreaTaskSuggestions(profileId as string),
    {
      enabled: !!profileId?.trim(),
      ...options,
    }
  )
}
